/** SPA shells that must not run visitor geo (Worker bypass + client guards). */
export const ADMIN_SHELL_PREFIXES = [
  "/admin",
  "/dashboard",
  "/portal",
  "/test-base-template",
  "/test-cta-buttons",
] as const;

/** Payment / gift funnels where the geo pill competes with fixed CTAs. */
const GEO_CONSENT_FUNNEL_PREFIXES = ["/r/cumple"] as const;

const GEO_CONSENT_EXCLUDED_PREFIXES = [
  ...GEO_CONSENT_FUNNEL_PREFIXES,
  ...ADMIN_SHELL_PREFIXES,
] as const;

function matchesPrefix(pathname: string, prefixes: readonly string[]): boolean {
  return prefixes.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}

/** Admin shell + internal utility routes (no public visitor intent). */
export function isAdminShellPath(pathname: string): boolean {
  return matchesPrefix(pathname, ADMIN_SHELL_PREFIXES);
}

/** Routes where the AR geolocation consent pill must not run. */
export function isGeoConsentExcludedPath(pathname: string): boolean {
  return matchesPrefix(pathname, GEO_CONSENT_EXCLUDED_PREFIXES);
}